// extracted by mini-css-extract-plugin
module.exports = {"root":"icon_root__WyaML"};